var metadata                = require('./_metadata')
  , anObject                = require('./_an-object')
  , ordinaryOwnMetadataKeys = metadata.keys
  , toMetaKey               = metadata.key;

metadata.exp({getOwnMetadataKeys: function getOwnMetadataKeys(target /*, targetKey */){
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
}});


//////////////////
// WEBPACK FOOTER
// ./~/babel-polyfill/~/core-js/modules/es7.reflect.get-own-metadata-keys.js
// module id = 734
// module chunks = 0